import type { DynamicPageProps } from '@/core/features/a-dynamic-page/dynamic-page-types';

import { getComponentId } from '@/core/features/a-component/services/component-id-service';
import { GroupV1 } from '@/features/_index/mobile';
import getFromPageComponentRegistry from '@/features/a-dynamic-page/components/page-component-registry';
import PageComponentSwitch from '@/features/a-dynamic-page/components/page-component-switch';
import { validateLayoutPosition } from '@/features/page-layouts/layout-validation-service';

export default function PageComponentSwitchWrapper(props: DynamicPageProps) {
    const pageComponentNames = props.components.map((component) => {
        return component['@type'];
    });

    return (
        <>
            {props.components.map((component, index) => {
                validateLayoutPosition(component);

                const componentType = component['@type'];
                const componentConfig = getFromPageComponentRegistry(componentType);

                if (componentType === 'GroupV1') {
                    return (
                        <GroupV1
                            componentId={getComponentId(component['@id'])}
                            componentTypeFilter={props.ssrProps.componentTypeFilter}
                            components={component.attributes.components}
                            getComponentConfig={getFromPageComponentRegistry}
                            htmlTitle={component.attributes.htmlTitle}
                            isPageLoading={props.isPageLoading}
                            isWidget={props.ssrProps.isWidget}
                            key={`${getComponentId(component['@id'])}-${index}`}
                            link={component.attributes.link}
                            meta={component.meta}
                            pageComponentNames={pageComponentNames}
                            title={component.attributes.title}
                        />
                    );
                }

                return (
                    <PageComponentSwitch
                        component={component}
                        componentConfig={componentConfig}
                        componentIndex={index}
                        componentTypeFilter={props.ssrProps.componentTypeFilter}
                        isPageLoading={props.isPageLoading}
                        isWidget={props.ssrProps.isWidget}
                        key={`${getComponentId(component['@id'])}-${index}`}
                        pageComponentNames={pageComponentNames}
                    />
                );
            })}
        </>
    );
}
